import posthog from "posthog-js";

export type SmartTablePresetAnalyticsType =
  | "model-comparison"
  | "brand-visibility"
  | "custom"
  | "GROUND_TRUTH_COMPARE"
  | "STRUCTURAL";

type SmartTableAnalyticsValue = string | number | boolean | null;
type SmartTableAnalyticsProperties = Record<string, SmartTableAnalyticsValue | undefined>;

const sanitizeProperties = (
  properties: SmartTableAnalyticsProperties,
): Record<string, SmartTableAnalyticsValue> =>
  Object.fromEntries(
    Object.entries(properties).filter(([, value]) => {
      if (value === undefined) {
        return false;
      }
      if (typeof value === "number" && Number.isNaN(value)) {
        return false;
      }
      return true;
    }),
  ) as Record<string, SmartTableAnalyticsValue>;

export const captureSmartTableEvent = (
  eventName: string,
  properties: SmartTableAnalyticsProperties,
): void => {
  posthog.capture(eventName, sanitizeProperties(properties));
};

export const captureSmartTablePresetCreated = ({
  workspaceId,
  smartTableId,
  presetType,
  promptRegistryId,
  promptVersionNumber,
}: {
  workspaceId: number;
  smartTableId: string;
  presetType: SmartTablePresetAnalyticsType;
  promptRegistryId?: number;
  promptVersionNumber?: number;
}): void => {
  captureSmartTableEvent("Smart Table Preset Created", {
    workspace_id: workspaceId,
    smart_table_id: smartTableId,
    preset_type: presetType,
    prompt_registry_id: promptRegistryId,
    prompt_version_number: promptVersionNumber,
  });
};
